const img = require('./Upgrades.svg'); export default img;